/* eslint-disable no-use-before-define */

/* eslint-disable no-unused-vars */

/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import {
  Animated,
  StyleProp,
  ViewStyle,
  TextStyle,
} from "react-native";
import SVG_Svg, {
  G as SVG_G,
  Path as SVG_Path,
  GProps,
  PathProps,
  Color,
} from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: desc */

/***/

const Path = Animated.createAnimatedComponent<
  React.ComponentClass<
    PathProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_Path);
const G = Animated.createAnimatedComponent<
  React.ComponentClass<
    GProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_G);
const Svg = Animated.createAnimatedComponent(SVG_Svg);

/*
 * -------------------------------------------------------------------------
 *
 *  /$$$$$$                                /$$$$$$$  /$$
 * |_  $$_/                               | $$__  $$| $$
 *   | $$   /$$$$$$/$$$$   /$$$$$$        | $$  \ $$| $$ /$$   /$$  /$$$$$$
 *   | $$  | $$_  $$_  $$ /$$__  $$       | $$$$$$$ | $$| $$  | $$ /$$__  $$
 *   | $$  | $$ \ $$ \ $$| $$  \ $$       | $$__  $$| $$| $$  | $$| $$$$$$$$
 *   | $$  | $$ | $$ | $$| $$  | $$       | $$  \ $$| $$| $$  | $$| $$_____/
 *  /$$$$$$| $$ | $$ | $$| $$$$$$$/  /$$  | $$$$$$$/| $$|  $$$$$$/|  $$$$$$$
 * |______/|__/ |__/ |__/| $$____/  |__/  |_______/ |__/ \______/  \_______/
 *                       | $$
 *                       | $$
 *                       |__/
 *
 * -------------------------------------------------------------------------
 *
 * ORIGINAL SVG
 * ---------------------------------
 * <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"> <desc id="IMP.BLUE"></desc>
 * <g id="DeleteIcon">
 * <path id="Line 1" fill-rule="evenodd" clip-rule="evenodd" d="M8.64648 9.35359L0.646484 1.35359L1.35359 0.646484L9.35359 8.64648L8.64648 9.35359Z" fill="black"/>
 * <path id="Line 2" fill-rule="evenodd" clip-rule="evenodd" d="M9.35359 1.35359L1.35359 9.35359L0.646484 8.64648L8.64648 0.646484L9.35359 1.35359Z" fill="black"/>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * CONFIGURATION
 * ---------------------------------
 * {}
 * ---------------------------------
 *
 * DESCRIPTION
 * ---------------------------------
 * No description provided!
 * ---------------------------------
 */

/** Component Properties Interface */
export type tProps = {
  style?: tStyle;
  svgStyle?: tStyle;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  onAnimationComplete?: () => void;
};
/***/

/***/

export type tStyle = StyleProp<ViewStyle>;
export type tTextStyle = StyleProp<TextStyle>;
/***/

/***/

/**
 * Auto-Generated Imp.Blue Component based on your design!
 * @param {tProps} props Developer interface to the component!
 * @returns {JSX.Element} JSX
 *
 * Description --
 * No description provided!
 */

export const DeleteIcon = (props: {
  style?: tStyle;
  svgStyle?: tStyle;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  onAnimationComplete?: () => void;
  color?: Color;
}): JSX.Element => {
  const {
    svgRef,
  } = props;
  /** End Custom React-Hooks */

  /** Component Render (Javascript-React Markup) */

  return (
    <Svg viewBox="0 0 10 10" fill="none" id="svg_root" ref={svgRef} {...props}>
      <G id="DeleteIcon">
        <Path
          id="Line_201"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.64648 9.35359L0.646484 1.35359L1.35359 0.646484L9.35359 8.64648L8.64648 9.35359Z"
          fill={props.color || "black"}
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
        <Path
          id="Line_202"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.35359 1.35359L1.35359 9.35359L0.646484 8.64648L8.64648 0.646484L9.35359 1.35359Z"
          fill={props.color || "black"}
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </G>
    </Svg>
  );
};
/***/

export default React.memo(DeleteIcon);
